module.exports = __webpack_public_path__ + "img/icon-time.a3eebcb0.svg";